import { t } from "../i18n";

export const LegalTexts = () => {
	return (
		<div className="legal_texts">
			<p>
				{t(
					"Responsable del tratamiento: RALARSA, S.A. (CIF A12345678)"
				)}
			</p>
			<p>
				{t("Contacto:")}{" "}
				<a href="mailto:privacidad@ralarsa.com">
					privacidad@ralarsa.com
				</a>{" "}
				/ +34 900 333 733
			</p>
			<p>
				{t(
					"Finalidad: gestionar tu solicitud de cita y contactarte para su confirmación. En caso de que inicies un proceso de solicitud de cita y no llegue a completarse, podremos contactar contigo telefónicamente con la finalidad de conocer tu experiencia en el proceso y mejorar nuestros servicios. La base jurídica de este tratamiento es el interés legítimo de la compañía en mejorar sus procesos y la calidad del servicio."
				)}
			</p>
			<p>
				{t(
					"Base jurídica: consentimiento del interesado (art. 6.1 a) RGPD."
				)}
			</p>
			<p>
				{t(
					"Derechos: tienes derecho a acceder, rectificar, suprimir, limitar y oponerte al tratamiento, así como a la portabilidad de tus datos y a retirar tu consentimiento en cualquier momento sin que ello afecte la licitud del tratamiento previo."
				)}
			</p>
			<p>
				{t("Reclamaciones: puedes presentar una reclamación ante la")}{" "}
				<a
					href="https://www.aepd.es/"
					target="_blank"
					rel="noopener noreferrer"
				>
					{t("AEPD")}
				</a>
			</p>
			<p>
				{t("Más información: consulta la")}{" "}
				<a
					href="https://www.ralarsa.com/es/privacidad/"
					target="_blank"
					rel="noopener noreferrer"
				>
					{t("política de privacidad")}
				</a>
			</p>
		</div>
	);
};
